export default __webpack_public_path__ + "static/media/tablet.13680978.svg";